import { render, staticRenderFns } from "./OrderNotesPanel.vue?vue&type=template&id=68adab36&scoped=true&"
import script from "./OrderNotesPanel.vue?vue&type=script&lang=js&"
export * from "./OrderNotesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68adab36",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68adab36')) {
      api.createRecord('68adab36', component.options)
    } else {
      api.reload('68adab36', component.options)
    }
    module.hot.accept("./OrderNotesPanel.vue?vue&type=template&id=68adab36&scoped=true&", function () {
      api.rerender('68adab36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/components/scheduled/OrderNotesPanel.vue"
export default component.exports